"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
exports.theme = {
    sizes: {
        default: 'h-4 w-4',
        medium: 'h-4 w-4',
        small: 'h-3.5 w-3.5',
        large: 'h-5 w-5',
        custom: '',
    },
};
//# sourceMappingURL=themes.js.map